// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"BO-z","upvoteIcon":"CO-z","downvoteIcon":"DO-z","feedbackIcon":"EO-z"};